import React from 'react';
import Slider from "react-slick";
import styled from "styled-components";
import iconLeft from "../images/icon-left.svg"
import iconRight from "../images/icon-right.svg"

import { colors } from '../style/vars';



const Carousel = ({ children }) => (
  <CarouselWrapper>
    <Slider autoplay dots infinite speed={500}>
      {children}
    </Slider>
  </CarouselWrapper>
)



const CarouselWrapper = styled.div`
  .slick-list, .slick-slider, .slick-track {
    position: relative;
    display: block;
  }

  .slick-loading .slick-slide, .slick-loading .slick-track {
    visibility: hidden; 
  }
  .slick-slider{
    box-sizing:border-box;
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
    -webkit-touch-callout:none;
    -khtml-user-select:none;
    -ms-touch-action:pan-y;
    touch-action:pan-y;
    -webkit-tap-highlight-color:transparent;
  }
  .slick-list{
    overflow:hidden;
    margin:0;
    padding:0;
  }
  .slick-list:focus{
    outline:0;
  }
  .slick-list.dragging{
    cursor:pointer;
    cursor:hand;
  }
  .slick-slider .slick-list,.slick-slider .slick-track{
    -webkit-transform:translate3d(0,0,0);
    -moz-transform:translate3d(0,0,0);
    -ms-transform:translate3d(0,0,0);
    -o-transform:translate3d(0,0,0);
    transform:translate3d(0,0,0);
  }
  .slick-track{
    top:0;
    left:0;
  }
  .slick-track:after,.slick-track:before{
    display:table;
    content:'';
  }
  .slick-track:after{
    clear:both;
  }
  .slick-slide{
    display:none;
    float:left;
    height:100%;
    min-height:1px;
  }
  [dir=rtl] .slick-slide{
    float:right;
  }
  .slick-slide img{
    display:block;
  }
  .slick-slide.slick-loading img{
    display:none;
  }
  .slick-slide.dragging img{
    pointer-events:none;
  }
  .slick-initialized .slick-slide{
    display:block;
  }
  .slick-vertical .slick-slide{
    display:block;
    height:auto;
    border:1px solid transparent;
  }
  .slick-arrow.slick-hidden{
    display:none;
  }

  .slick-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    font-size: 0;
    width: 1.5rem;
    height: 1.5rem;
    cursor: pointer;
    opacity: 0.8;
    transition: 0.15s opacity;

    :hover {
      opacity: 1;
    }
  }

  .slick-next {
    right: 1rem;
    background: url(${iconRight}) no-repeat 50% 50%;
  }

  .slick-prev {
    left: 1rem;
    background: url(${iconLeft}) no-repeat 50% 50%;
  }

  img {
    display: block !important;
  }

  .slick-dots {
    position: absolute;
    bottom: 2.25rem;
    text-align: center;
    display: flex !important;
    justify-content: center;
    width: 100%;
    left: 0;
    list-style: none;

    button {
      background: none;
      font-size: 0;
      display: block;
      color: transparent;
      cursor: pointer;

      :after {
        content: "";
        display: block;
        margin: 1rem;
        width: 50px;
        height: 2px;
        background: #fff;

      }
    }

    .slick-active button:after {
      background: ${colors.brandPrimary};
    }

    li {
      flex: 0 0 auto;
    }
  }
`



export default Carousel
